import React from "react";
import { LiveContentWrapper, LiveSectionWrapper } from "./style";
import CardListHeader from "../../components/shared-components/CardListHeader";
import { NftBuyer, SpotLightThumb, SpotLightThumb1 } from "../../shared/icons";
import { Button } from "../../components/Buttons";

function LiveDropSection() {
  return (
    <LiveSectionWrapper>
      <CardListHeader headingTitle="Live Drops" />
      <LiveContentWrapper>
        <ul>
          <li>
            <img src={SpotLightThumb} alt="icon" />
          </li>
          <li>
            <p>
              <span>Live Now</span>
            </p>
            <h2>Future Rewind Competition</h2>
            <p>
              For Metaverse Fashion Week 2023, Dolce&Gabbana and UNXD are
              launching a digital wearable competition to shine a light on
              emerging talent. The Future Rewind Competition marks the first
              time a traditional luxury brand has offered direct and personal
              mentorship in empowering a new generation of digital creators.
            </p>
            <div>
              <Button>Explore Drop</Button>
              <div>
                <img src={NftBuyer} alt="icon" />
                <span>Created by | Meteor</span>
              </div>
            </div>
          </li>
        </ul>
      </LiveContentWrapper>
      <LiveContentWrapper>
        <ul>
          <li>
            <img src={SpotLightThumb1} alt="icon" />
          </li>
          <li>
            <p>
              <span>Live Now</span>
            </p>
            <h2>Digital Elegance Art</h2>
            <p>
              Explore limited-edition NFT drops and curated collections designed
              to inspire and engage. Join us in celebrating innovation and
              creativity through digital art and assets. Don’t miss your chance
              to own a piece of the future. Every drop is a step toward
              revolutionizing the way we own and share art.
            </p>
            <div>
              <Button>Explore Drop</Button>
              <div>
                <img src={NftBuyer} alt="icon" />
                <span>Created by | Meteor</span>
              </div>
            </div>
          </li>
        </ul>
      </LiveContentWrapper>
    </LiveSectionWrapper>
  );
}

export default LiveDropSection;
